import React from "react";
import { useState } from "react";
import { Table, Input, Button, Empty, Icon } from "antd";
import { useEffect } from "react";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { Translation } from "react-i18next";
import i18next from "i18next";

function FilterablePaginatedTable(props) {
  let { onTableParamsChange = () => {}, filterableColumns = [] } = props;
  let [columns, setColumns] = useState([]);
  let [tableParams, setTableParams] = useState(
    props.tableParams ?? props.tableParams
  );

  let pagination = {
    total: props.total,
    pageSize: tableParams ? tableParams.pagination.pageSize : 10,
    current: tableParams ? tableParams.pagination.current : 1,
    itemRender: (current, type, originalElement) => {
      if (type === "prev") {
        return (
          <a className="ant-pagination-item-link">
            <Icon type={props.context.curr_dir === "rtl" ? "right" : "left"} />
          </a>
        );
      }
      if (type === "next") {
        return (
          <a className="ant-pagination-item-link">
            <Icon type={props.context.curr_dir === "rtl" ? "left" : "right"} />
          </a>
        );
      }
      return originalElement;
    },
  };
  function handleChangeTable(pagination, filters, sorter) {
    setTableParams({
      pagination,
      filters: tableParams?.filters ? tableParams.filters : undefined,
      sorter,
    });
  }

  function handleTableChange(pagination, filters, sorter) {
    setTableParams({
      pagination,
      filters: tableParams?.filters ? tableParams.filters : undefined,
      sorter,
    });
  }
  useEffect(() => {
    setColumns(
      props.columns.map((column) => {
        if (filterableColumns.includes(column["key"])) {
          return {
            ...column,
            ...getColumnSearchProps(column["dataIndex"]),
          };
        } else {
          return {
            ...column,
          };
        }
      })
    );
  }, [props.columns, props.filterableColumns]);

  useEffect(() => {
    onTableParamsChange(tableParams);
  }, [tableParams]);

  useEffect(() => {
    setTableParams(props.tableParams);
  }, []);

  //   const getColumnSearchProps = (dataIndex) => ({
  //   filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
  //     <div style={{ padding: 8 }}>
  //       <Input
  //         placeholder={`Search ${dataIndex}`}
  //         value={selectedKeys[0]}
  //         onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
  //         onPressEnter={() => {
  //           confirm();
  //           handleSearch(dataIndex, selectedKeys);
  //         }}
  //         style={{ width: 188, marginBottom: 8, display: "block" }}
  //       />
  //       <Button
  //         type="primary"
  //         onClick={() => {
  //           confirm();
  //           handleSearch(dataIndex, selectedKeys);
  //         }}
  //         icon={<SearchOutlined />}
  //         size="small"
  //         style={{ width: 90, marginRight: 8 }}
  //       >
  //         Search
  //       </Button>
  //       <Button
  //         onClick={() => handleReset(dataIndex, clearFilters, close)}
  //         size="small"
  //         style={{ width: 90 }}
  //       >
  //         Reset
  //       </Button>
  //     </div>
  //   ),
  //   filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? "#d73a31" : undefined }} />,
  // });
  function getColumnSearchProps(dataIndex) {
    return {
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
        close,
      }) => {
        return (
          <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
            <Input
              placeholder={`Search ${dataIndex}`}
              value={selectedKeys[0]}
              onChange={(e) =>
                setSelectedKeys(e.target.value ? [e.target.value] : [])
              }
              onPressEnter={() => {
                confirm();
                handleSearch(dataIndex, selectedKeys);
              }}
              style={{ marginBottom: 8, display: "block" }}
            />
            <Button
              type="primary"
              onClick={() => {
                confirm();
                handleSearch(dataIndex, selectedKeys);
              }}
              icon="search"
              size="small"
              style={{ width: 90, marginRight: 8 }}
            >
              Search
            </Button>
            <Button
              onClick={() =>
                clearFilters &&
                handleReset(dataIndex, clearFilters, confirm, close)
              }
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
          </div>
        );
      },
      filterIcon: (filtered) => (
        <Icon type="search" style={{ color: "#d73a31" }} />
      ),
    };
  }

  function handleSearch(dataIndex, selectedKeys) {
    console.log(
      "============ dataIndex, selectedKeys",
      dataIndex,
      selectedKeys
    );
    setTableParams({
      ...tableParams,
      filters: {
        ...tableParams.filters,
        [dataIndex]: selectedKeys[0],
      },
    });
  }

  function handleReset(dataIndex, clearFilters, close) {
    clearFilters();
    setTableParams({
      ...tableParams,
      filters: {
        ...tableParams.filters,
        [dataIndex]: undefined,
      },
    });
    close();
  }

  return (
    <Table
      {...props}
      columns={columns}
      rowKey={props.rowKey}
      pagination={{ ...pagination }}
      onChange={handleTableChange}
      bordered
      bodyStyle={{
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px",
        marginBottom: "25px",
      }}
      locale={{
        emptyText: (
          <Empty
            description={i18next.t("Empty")}
            image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
        ),
      }}
    />
  );
}
export default withSharedStateConsumer(FilterablePaginatedTable);
